import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { portalLogin } from '../services/portalService';
import { clearTokens, getAccessToken } from '../../services/api/apiClient';
import { verifyMfa } from '../../services/api/authService';
import { loadPortalData } from './portalSlice';

export const login = createAsyncThunk('portalAuth/login', async ({ email, password }) => portalLogin(email, password));
export const verifyPortalMfa = createAsyncThunk('portalAuth/verifyMfa', async ({ challengeToken, code }) => verifyMfa(challengeToken, code));

const portalAuthSlice = createSlice({
  name: 'portalAuth',
  initialState: { status: 'idle', error: null, isAuthenticated: Boolean(getAccessToken()), email: null, orgName: null, challengeToken: null },
  reducers: {
    logout(state) {
      clearTokens();
      state.isAuthenticated = false;
      state.email = null;
      state.orgName = null;
      state.challengeToken = null;
      state.status = 'idle';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => { state.status = 'loading'; state.error = null; })
      .addCase(login.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.error = null;
        if (action.payload.mfaRequired) {
          state.isAuthenticated = false;
          state.challengeToken = action.payload.mfaChallengeToken;
          state.email = action.payload.email;
        } else {
          state.isAuthenticated = true;
          state.challengeToken = null;
          state.email = action.payload.email;
          state.orgName = action.payload.orgName;
        }
      })
      .addCase(login.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Login failed.';
      })
      .addCase(verifyPortalMfa.pending, (state) => { state.status = 'loading'; state.error = null; })
      .addCase(verifyPortalMfa.fulfilled, (state) => {
        state.status = 'succeeded';
        state.isAuthenticated = true;
        state.challengeToken = null;
        state.error = null;
      })
      .addCase(verifyPortalMfa.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'MFA verification failed.';
      })
      .addCase(loadPortalData.fulfilled, (state, action) => {
        // login() only had a placeholder org name to work with (see
        // portalService.portalLogin) — this replaces it with the real
        // value the moment /portal/overview resolves it.
        if (action.payload.overview?.orgName) state.orgName = action.payload.overview.orgName;
      });
  }
});

export const { logout } = portalAuthSlice.actions;
export default portalAuthSlice.reducer;
